import { useQuery } from "@tanstack/react-query";
import { jsonFetch } from "@/lib/json-fetch";
import { appInfoKeys } from "@/lib/query";
import type { ReleaseNotes } from "@/schemas/release-notes";

export interface AppInfo {
  /** package.json version of the running server; null when it couldn't be read. */
  version: string | null;
  /** The release summary for `version`; null when that version has none. */
  release: ReleaseNotes | null;
}

/** The running app's version and its release summary. Fixed for the life of a deploy, so never refetched. */
export function useAppInfo() {
  return useQuery({
    queryKey: appInfoKeys.all,
    queryFn: () => jsonFetch<AppInfo>("/api/app-info"),
    staleTime: Number.POSITIVE_INFINITY,
  });
}
